import type { Ancestor } from "@/entities/ancestor";

import { getOrganizationAncestor } from "@/entities/ancestor";
import { useGetCurrentUserOrganization } from "@/entities/current-user";

export const useOrganizationSelectOptionValue = (ancestors: Ancestor[]) => {
  const { organization: defaultOrganization, isLoading } =
    useGetCurrentUserOrganization();

  const organization =
    getOrganizationAncestor(ancestors) ?? defaultOrganization;

  return {
    isLoading: !organization && isLoading,
    organizationSelectValue: {
      value: organization?.id,
      label: organization?.name,
      key: organization?.id,
    },
  };
};
